import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import { GC_USER_ID } from '@/constants'
import { booksQuery } from '@/graphql/queries/book'
import { currentBookPref } from '@/graphql/queries/bookPref'
import {
  newCurrentBookPref,
  updateCurrentBookPref
} from '@/graphql/mutations/bookPref'

import {
  Modal,
  Typography,
  Paper,
  GridList,
  GridListTile,
  CircularProgress,
  LinearProgress
} from 'material-ui'
import List, { ListItem, ListItemText } from 'material-ui/List'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import EditIcon from 'material-ui-icons/Edit'
import BookEditModal from '../modals/BookEdit'
import ImportContactsIcon from 'material-ui-icons/ImportContacts'
import CheckIcon from 'material-ui-icons/Check'
import AddIcon from 'material-ui-icons/Add'

@graphql(newCurrentBookPref, {
  name: 'newCurrentBookPref',
  options: {
    refetchQueries: ['currentBookPref']
  }
})
@graphql(updateCurrentBookPref, {
  name: 'updateCurrentBookPref',
  options: {
    refetchQueries: ['currentBookPref']
  }
})
@graphql(currentBookPref, {
  name: 'currentBookPref',
  options: () => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      isCurrent: true
    }
  })
})
@graphql(booksQuery, {
  name: 'booksQuery',
  options: () => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
export default class BooksModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bookTypeSelected: 'To Read',
      open: false,
      OpenBook: false,
      book: '',
      action: ''
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
  }

  handleFilterChange = filter => {
    this.setState({ bookTypeSelected: filter })
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleBookEdit = (action, book) => {
    this.setState({
      action: action
    })
    if (action === 'add') {
      var newBook = {
        name: '',
        author: '',
        totalPages: ''
      }
      this.setState({ book: newBook })
    } else if (action === 'edit') {
      this.setState({ book: book })
    }
    this.setState({
      OpenBook: true
    })
  }

  handleCloseBook = () => {
    this.setState({
      OpenBook: false
    })
  }

  handleSelectBook = book => {
    if (
      this.props.currentBookPref.allBookPrefs &&
      this.props.currentBookPref.allBookPrefs.length === 1
    ) {
      if (this.props.currentBookPref.allBookPrefs[0].book.id === book.id) {
        //no change needed
        this.props.onClose()
        this.setState({
          open: false
        })
        return
      }
      //change current book status to false
      this.props
        .updateCurrentBookPref({
          variables: {
            isCurrent: false,
            id: this.props.currentBookPref.allBookPrefs[0].id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false
          })
        })
    }

    if (book.bookPrefs.length === 0) {
      //create a new bookPref and set as current
      this.props
        .newCurrentBookPref({
          variables: {
            isCurrent: true,
            bookId: book.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(data => {
          this.props.update(
            book.id,
            book.name,
            data.data.createBookPref.id,
            0,
            book.totalPages
          )
          this.props.onClose()
          this.setState({
            open: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false
          })
        })
    } else if (book.bookPrefs.length === 1) {
      var id = book.bookPrefs[0].id
      //change select book curreent status to true
      this.props
        .updateCurrentBookPref({
          variables: {
            isCurrent: true,
            id: id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.update(
            book.id,
            book.name,
            book.bookPrefs[0].id,
            book.bookPrefs[0].maxPage,
            book.totalPages
          )
          this.props.onClose()
          this.setState({
            open: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false
          })
        })
    } else if (book.bookPrefs.length > 1) {
      console.log(
        'Err: more than one current book... please contact support team!'
      )
    } else {
      console.log('Err: pref fiels missing... please contact support team!')
    }
  }

  render() {
    if (this.props.booksQuery.loading) {
      return (
        <div>
          <CircularProgress
            style={{
              margin: 5,
              color: 'lightgrey'
            }}
            size={40}
          />
        </div>
      )
    }
    if (this.props.currentBookPref.loading) {
      return (
        <div>
          <CircularProgress
            style={{
              margin: 5,
              color: 'lightgrey'
            }}
            size={40}
          />
        </div>
      )
    }
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddToday">
            <div
              id="GetUpTime"
              className="divAddTpday"
              style={{ borderRadius: 16 }}
            >
              <List>
                <ListItem divider>
                  <ListItemText
                    className="modalHealder"
                    primary={
                      <Typography
                        variant="body1"
                        style={{ fontSize: 18, color: 'grey' }}
                      >
                        Which book would you like?
                      </Typography>
                    }
                  />
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleClose}
                  >
                    <ClearIcon className="iconClear" />
                  </IconButton>
                </ListItem>
                <ListItem>
                  <div className="divText">
                    <Typography
                      onClick={() => this.handleFilterChange('To Read')}
                      variant="caption"
                      className={
                        this.state.bookTypeSelected === 'To Read'
                          ? 'textFilter'
                          : 'textFilterGery'
                      }
                    >
                      To Read
                    </Typography>
                    <Typography
                      onClick={() => this.handleFilterChange('Reading')}
                      variant="caption"
                      className={
                        this.state.bookTypeSelected === 'Reading'
                          ? 'textFilter'
                          : 'textFilterGery'
                      }
                    >
                      Reading
                    </Typography>
                    <Typography
                      onClick={() => this.handleFilterChange('Completed')}
                      variant="caption"
                      className={
                        this.state.bookTypeSelected === 'Completed'
                          ? 'textFilter'
                          : 'textFilterGery'
                      }
                    >
                      Completed
                    </Typography>
                    <Typography
                      onClick={() => this.handleFilterChange('More')}
                      variant="caption"
                      className={
                        this.state.bookTypeSelected === 'More'
                          ? 'textFilter'
                          : 'textFilterGery'
                      }
                    >
                      Add More
                    </Typography>
                  </div>
                </ListItem>
              </List>
              <GridList className="gridList" cols={4}>
                <GridListTile
                  xs={6}
                  cols={1}
                  key={'add'}
                  style={{ height: 140 }}
                >
                  {this.state.bookTypeSelected === 'More' && (
                    <Paper
                      style={{
                        backgroundColor: 'white',
                        boxShadow: '0px 0px 10px #dddddd'
                      }}
                      className="paperBlockBook"
                      onClick={() => this.handleBookEdit('add', '')}
                    >
                      <div key={`bookblock-key-add`} className="bookBlock">
                        <AddIcon
                          style={{
                            fontSize: 60,
                            color: 'rgba(0, 0, 0, 0.1)',
                            paddingTop: 15
                          }}
                        />
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 2,
                            textAlign: 'center',
                            fontSize: 12,
                            color: 'grey',
                            lineHeight: 1.1
                          }}
                        >
                          Add
                        </Typography>
                      </div>
                    </Paper>
                  )}
                  {this.state.bookTypeSelected === 'To Read' && (
                    <Paper
                      style={{
                        backgroundColor: 'white',
                        boxShadow: '0px 0px 10px #dddddd'
                      }}
                      className="paperBlockBook"
                    >
                      <div key={`bookblock-key-add`} className="bookBlock">
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingTop: 15,
                            paddingLeft: 5,
                            paddingRight: 5,
                            textAlign: 'center',
                            fontSize: 14,
                            color: 'lightgrey',
                            lineHeight: 1.1
                          }}
                        >
                          {this.props.booksQuery &&
                          this.props.booksQuery.allBooks &&
                          this.props.booksQuery.allBooks.filter(
                            e =>
                              e.bookPrefs.length === 1 &&
                              e.bookPrefs[0].percentRead < 1
                          ).length === 0
                            ? "You haven't added any new books yet ..."
                            : 'Pick one and start reading  ⇢'}
                        </Typography>
                      </div>
                    </Paper>
                  )}
                  {this.state.bookTypeSelected === 'Reading' && (
                    <Paper
                      style={{
                        backgroundColor: 'white',
                        boxShadow: '0px 0px 10px #dddddd'
                      }}
                      className="paperBlockBook"
                    >
                      <div key={`bookblock-key-add`} className="bookBlock">
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingTop: 15,
                            paddingLeft: 5,
                            paddingRight: 5,
                            textAlign: 'center',
                            fontSize: 14,
                            color: 'lightgrey',
                            lineHeight: 1.1
                          }}
                        >
                          {this.props.booksQuery.allBooks.filter(
                            e =>
                              e.bookPrefs.length === 1 &&
                              e.bookPrefs[0].percentRead > 0 &&
                              e.bookPrefs[0].percentRead < 100
                          ).length === 0
                            ? "You haven't started any books yet ..."
                            : 'Pick one and start complete it  ⇢'}
                        </Typography>
                      </div>
                    </Paper>
                  )}
                  {this.state.bookTypeSelected === 'Completed' && (
                    <Paper
                      style={{
                        backgroundColor: 'white',
                        boxShadow: '0px 0px 10px #dddddd'
                      }}
                      className="paperBlockBook"
                    >
                      <div key={`bookblock-key-add`} className="bookBlock">
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingTop: 15,
                            paddingLeft: 5,
                            paddingRight: 5,
                            textAlign: 'center',
                            fontSize: 14,
                            color: 'lightgrey',
                            lineHeight: 1.1
                          }}
                        >
                          {this.props.booksQuery.allBooks.filter(
                            e =>
                              e.bookPrefs.length === 1 &&
                              e.bookPrefs[0].percentRead >= 100
                          ).length === 0
                            ? "You haven't completed any books yet ..."
                            : 'Re-read a completed book ⇢'}
                        </Typography>
                      </div>
                    </Paper>
                  )}
                </GridListTile>
                {this.props.booksQuery.allBooks
                  .filter(
                    e =>
                      this.state.bookTypeSelected === 'Reading'
                        ? e.bookPrefs.length === 1 &&
                          e.bookPrefs[0].percentRead > 0 &&
                          e.bookPrefs[0].percentRead < 100
                        : this.state.bookTypeSelected === 'Completed'
                          ? e.bookPrefs.length === 1 &&
                            e.bookPrefs[0].percentRead >= 100
                          : this.state.bookTypeSelected === 'To Read'
                            ? e.bookPrefs.length === 1 &&
                              e.bookPrefs[0].percentRead < 1
                            : this.state.bookTypeSelected === 'More'
                              ? e.bookPrefs.length === 0
                              : e.bookPrefs.length < 2
                  )
                  .map((e, index) => (
                    <GridListTile
                      xs={6}
                      cols={1}
                      key={e.id}
                      style={{ height: 140 }}
                    >
                      <Paper
                        style={{
                          backgroundColor: 'rgba(222, 184, 135, 0.1)',
                          boxShadow: '0px 0px 10px #dddddd'
                        }}
                        className="paperBlockBook"
                        onClick={() => this.handleSelectBook(e)}
                      >
                        <div
                          key={`bookblock-key-${index}`}
                          className="bookBlock"
                        >
                          <ImportContactsIcon
                            style={{
                              fontSize: 40,
                              color: 'rgba(0, 0, 0, 0.1)'
                            }}
                          />
                          <Typography
                            variant="body1"
                            id="bookName"
                            style={{
                              paddingLeft: 8,
                              paddingRight: 2,
                              textAlign: 'left',
                              fontSize: 12
                            }}
                          >
                            {e.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            id="bookAuthor"
                            style={{
                              paddingLeft: 8,
                              paddingRight: 8,
                              fontSize: 9,
                              textAlign: 'left'
                            }}
                          >
                            {e.author}
                          </Typography>
                        </div>
                      </Paper>

                      <div className="divAddModalButton">
                        {e.bookPrefs.length !== 1 ? (
                          ''
                        ) : e.bookPrefs[0].percentRead < 1 ? (
                          ''
                        ) : (
                          <div className="progressBar">
                            {e.bookPrefs[0].percentRead < 100 ? (
                              <span
                                style={{ fontSize: 10, color: 'lightgrey' }}
                              >
                                {e.bookPrefs[0].percentRead}%
                              </span>
                            ) : (
                              <CheckIcon
                                style={{ color: 'lightgreen', fontSize: 12 }}
                              />
                            )}
                            <LinearProgress
                              variant="determinate"
                              color={
                                e.bookPrefs[0].percentRead >= 100
                                  ? 'secondary'
                                  : 'primary'
                              }
                              value={e.bookPrefs[0].percentRead}
                            />
                          </div>
                        )}
                        <div
                          className="iconBtnEditSmall"
                          onClick={() => this.handleBookEdit('edit', e)}
                        >
                          <EditIcon
                            style={{
                              fontSize: 18,
                              color: 'rgba(0, 0, 0, 0.1)'
                            }}
                          />
                        </div>
                      </div>
                    </GridListTile>
                  ))}
              </GridList>
            </div>
          </Paper>
        </Modal>
        <BookEditModal
          open={this.state.OpenBook}
          onClose={this.handleCloseBook}
          book={this.state.book}
          action={this.state.action}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/Books.js